// Display helpers shared by the marketplace and member pages.

const locale = (lang) => (lang === 'en' ? 'en-CA' : 'fr-CA');

// "US$1,200.00 – US$1,500.00 / tonne" (range and unit when given).
export function formatPrice(listing, lang, t) {
  if (listing.priceOnRequest || listing.price === null || listing.price === undefined) return t('marketplace.priceOnRequest');
  const fmt = new Intl.NumberFormat(locale(lang), { style: 'currency', currency: listing.currency || 'CAD' });
  let s = fmt.format(listing.price);
  if (listing.priceMax && listing.priceMax > listing.price) s += ` – ${fmt.format(listing.priceMax)}`;
  if (listing.priceUnit) s += ` / ${t(`units.${listing.priceUnit}`)}`;
  return s;
}

export function formatQuantity(listing, lang) {
  if (listing.quantity === null || listing.quantity === undefined) return null;
  const n = new Intl.NumberFormat(locale(lang), { maximumFractionDigits: 2 }).format(listing.quantity);
  return listing.unit ? `${n} ${listing.unit}` : n;
}

// A date-only value ("2019-03-01") is a calendar day, not UTC midnight
// (which shows as the day before in Montreal).
const toDate = (v) => (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v) ? new Date(Number(v.slice(0, 4)), Number(v.slice(5, 7)) - 1, Number(v.slice(8, 10))) : new Date(v));
export const formatDate = (iso, lang) =>
  iso ? toDate(iso).toLocaleDateString(locale(lang), { year: 'numeric', month: 'long', day: 'numeric' }) : '';

export const categoryName = (category, lang) => (category ? (lang === 'en' ? category.nameEn : category.nameFr) : '');

export function placeName(seller, t) {
  const province = seller?.province ? t(`provinces.${seller.province}`) : '';
  return [seller?.city, province].filter(Boolean).join(', ');
}
